import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'; 
import { Meta } from '@angular/platform-browser';
import { SeoService} from './service/seo/seo.service'




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'parking';
  constructor(public router: Router,private metaTagService: Meta,
               private seoService: SeoService
    
    ) {

    
  }
  ngOnInit() {
    this.seoService.setCanonicalURL();

    this.metaTagService.addTags([
      { name: 'description', content: 'LAX parking at discounted rates.Free airport shuttles. Complimentary Uber/Lyft drop off and pick up at LAX. Lots are secure and open 24/7' },
      { name: 'keywords', content: 'Spacious indoor parking spots, LAX parking, safe and secure in LAX,  Los Angeles International Airport (LAX) Parking' },
      { name: 'robots', content: 'index, follow' },
      { charset: 'UTF-8' }
    ]);
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
  }
}
